module.exports = __webpack_public_path__ + "img/11-detail.694af149.jpeg";